import { DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'
import SecureUserIllustration from 'images/organization/homepage/sections/solutions/solutionsSectionIcons/secure.png'
import ProtectNetworkIllustration from 'images/organization/homepage/sections/solutions/solutionsSectionIcons/protectnetwork.png'
import ActionableInsightsIllustration from 'images/organization/homepage/sections/solutions/solutionsSectionIcons/actionableinsights.png'
import BlockUnwantedContentIllustration from 'images/organization/homepage/sections/solutions/solutionsSectionIcons/block-unwanted-content.png'
import RegainPrivacyIllustration from 'images/organization/homepage/sections/solutions/solutionsSectionIcons/illustration.png'
import { SolutionType } from 'components/HomePage/Header/menus/solutions'
import { numberOfServices } from 'components/Plans/SelectPlan/SelectPlan'

export interface SolutionItem {
  title: string
  subText: string
  features: string[]
  url: string
  illustration: string
  type: SolutionType
}

export const solutionsData: SolutionItem[] = [
  {
    title: 'Secure End User Devices',
    subText:
      'Protect your staff from malicious attacks, phishing and harmful online content with a handful of clicks. Bad things can’t reach their device if they don’t resolve.',
    features: [
      'Roaming clients for all OSes',
      'Compatible with most RMM/MDM platforms',
      'Self-onboarding flows for unmanaged devices',
    ],
    url: `${DOCS_CONTROL_D_DOMAIN}/docs/secure-end-user-devices`,
    illustration: SecureUserIllustration,
    type: SolutionType.DeviceSecurity,
  },
  {
    title: 'Protect Whole Networks',
    subText:
      'Safeguard against threats before a connection is even made. Block malware, cryptojacking and phishing domains across entire networks by deploying Control D on a router.',
    features: [
      'Bespoke domain and IP level blocklists',
      'Machine learning based filtering',
      '1-step setup on many routers',
    ],
    url: `/solutions/network-security`,
    illustration: ProtectNetworkIllustration,
    type: SolutionType.NetworkProtection,
  },
  {
    title: 'Block Unwanted Content',
    subText:
      'Ads, clickbait, social media and porn can be harmful to the productivity of your business. Block unwanted content across networks, or on individual devices with a single click. Create blocking schedules for dynamic behaviors.',
    features: [
      '20+ filtering categories',
      `${numberOfServices} individually blockable services`,
      'Custom Rules for granular control',
    ],
    url: `${DOCS_CONTROL_D_DOMAIN}/docs/block-unwanted-content`,
    illustration: BlockUnwantedContentIllustration,
    type: SolutionType.ContentFiltering,
  },
  {
    title: 'Gain Actionable Insights',
    subText:
      'Optionally log every DNS query, from every device and gain insights on the activity of your end-users and whole networks.',
    features: [
      'View historical statistics',
      'Stream real-time logs into your SIEM',
      'Choose jurisdiction where your data is stored',
    ],
    url: `${DOCS_CONTROL_D_DOMAIN}/docs/gain-actionable-insights`,
    illustration: ActionableInsightsIllustration,
    type: SolutionType.DataInsights,
  },
  {
    title: 'Regain Privacy',
    subText:
      'Privacy and security go hand in hand. Block ads and trackers that can be used to spread malware via a single click and mask your IP from some or all websites you visit.',
    features: [
      'Reduce page load times by blocking trackers',
      'Enjoy ad-free browsing experience on mobile',
      'Mask your location without a VPN',
    ],
    url: `${DOCS_CONTROL_D_DOMAIN}/docs/regain-privacy`,
    illustration: RegainPrivacyIllustration,
    type: SolutionType.PrivacyShield,
  },
]
